import { Route, Routes } from "react-router-dom";
import Home from "./screens/home/Home";
import Booking from "./screens/booking/Booking";
import "./App.css";
import NotFound from "./screens/extras/404";
import Ticket from "./screens/ticket/Ticket";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="booking" element={<Booking />} />
      <Route path="404" element={<NotFound />} />
      <Route path="ticket/:id" element={<Ticket />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
